import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_unreviewed_client_posts = _resolveComponent("unreviewed-client-posts")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_escalated_client_posts = _resolveComponent("escalated-client-posts")!
  const _component_flagged_client_posts = _resolveComponent("flagged-client-posts")!
  const _component_timeline = _resolveComponent("timeline")!
  const _component_searches = _resolveComponent("searches")!
  const _component_reports = _resolveComponent("reports")!
  const _component_PeopleTab = _resolveComponent("PeopleTab")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_tabs, {
      "model-value": _ctx.tab,
      "active-color": "primary",
      "active-bg-color": "grey-1",
      "indicator-color": "primary",
      align: "justify",
      "narrow-indicator": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_route_tab, {
          name: "unreviewed",
          label: 'Unreviewed (' + _ctx.client.totalUnreviewed + ')',
          to: _ctx.tabRoute('unreviewed')
        }, null, 8, ["label", "to"]),
        _createVNode(_component_q_route_tab, {
          name: "escalated",
          label: "Escalated",
          to: _ctx.tabRoute('escalated')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_badge, {
              color: "warning",
              floating: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.client.totalEscalated), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_q_route_tab, {
          name: "flagged",
          label: 'Flagged (' + _ctx.client.totalFlagged + ')',
          to: _ctx.tabRoute('flagged')
        }, null, 8, ["label", "to"]),
        _createVNode(_component_q_route_tab, {
          name: "timeline",
          label: 'Timeline (' + _ctx.client.totalTimeline + ')',
          to: _ctx.tabRoute('timeline')
        }, null, 8, ["label", "to"]),
        _createVNode(_component_q_route_tab, {
          name: "reports",
          label: 'Reports (' + _ctx.client.totalReports + ')',
          to: _ctx.tabRoute('reports')
        }, null, 8, ["label", "to"]),
        _createVNode(_component_q_route_tab, {
          name: "search",
          label: "Search",
          to: _ctx.tabRoute('search')
        }, null, 8, ["to"]),
        _createVNode(_component_q_route_tab, {
          name: "people",
          label: 'People (' + _ctx.client.totalPersons + ')',
          to: _ctx.tabRoute('people')
        }, null, 8, ["label", "to"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_q_tab_panels, {
      "model-value": _ctx.tab,
      class: "bg-grey-1 q-px-md",
      animated: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab_panel, {
          name: "unreviewed",
          class: "no-scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_unreviewed_client_posts, { client: _ctx.client }, null, 8, ["client"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, {
          name: "escalated",
          class: "no-scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_escalated_client_posts, { client: _ctx.client }, null, 8, ["client"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, {
          name: "flagged",
          class: "no-scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_flagged_client_posts, { client: _ctx.client }, null, 8, ["client"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, { name: "timeline" }, {
          default: _withCtx(() => [
            _createVNode(_component_timeline, { client: _ctx.client }, null, 8, ["client"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, { name: "search" }, {
          default: _withCtx(() => [
            _createVNode(_component_searches, {
              "client-id": _ctx.client.id
            }, null, 8, ["client-id"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, { name: "reports" }, {
          default: _withCtx(() => [
            _createVNode(_component_reports, { client: _ctx.client }, null, 8, ["client"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, { name: "people" }, {
          default: _withCtx(() => [
            _createVNode(_component_PeopleTab, { client: _ctx.client }, null, 8, ["client"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}